/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Faq_Q5Inputs */

const en_pricing_faq_q5 = /** @type {(inputs: Pricing_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I buy extra credits?`)
};

const de_pricing_faq_q5 = /** @type {(inputs: Pricing_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann ich zusaetzliche Credits kaufen?`)
};

const fr_pricing_faq_q5 = /** @type {(inputs: Pricing_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do unused credits roll over to the next month?`)
};

const es_pricing_faq_q5 = /** @type {(inputs: Pricing_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do unused credits roll over to the next month?`)
};

const it_pricing_faq_q5 = /** @type {(inputs: Pricing_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do unused credits roll over to the next month?`)
};

const nl_pricing_faq_q5 = /** @type {(inputs: Pricing_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do unused credits roll over to the next month?`)
};

const pl_pricing_faq_q5 = /** @type {(inputs: Pricing_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do unused credits roll over to the next month?`)
};

const fi_pricing_faq_q5 = /** @type {(inputs: Pricing_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do unused credits roll over to the next month?`)
};

const da_pricing_faq_q5 = /** @type {(inputs: Pricing_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do unused credits roll over to the next month?`)
};

const sv_pricing_faq_q5 = /** @type {(inputs: Pricing_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do unused credits roll over to the next month?`)
};

/**
* | output |
* | --- |
* | "Can I buy extra credits?" |
*
* @param {Pricing_Faq_Q5Inputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_faq_q5 = /** @type {((inputs?: Pricing_Faq_Q5Inputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Faq_Q5Inputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_faq_q5(inputs)
	if (locale === "fr") return fr_pricing_faq_q5(inputs)
	if (locale === "es") return es_pricing_faq_q5(inputs)
	if (locale === "it") return it_pricing_faq_q5(inputs)
	if (locale === "nl") return nl_pricing_faq_q5(inputs)
	if (locale === "pl") return pl_pricing_faq_q5(inputs)
	if (locale === "fi") return fi_pricing_faq_q5(inputs)
	if (locale === "da") return da_pricing_faq_q5(inputs)
	if (locale === "sv") return sv_pricing_faq_q5(inputs)
	return en_pricing_faq_q5(inputs)
});